import {AxiosError} from 'axios'
import {UseMutationOptions} from 'react-query'

import {API} from '../../../networking/http'

export type PayNextSubscriptionCycleOptions = {
  data: {
    venueId: string
    additionalPaymentData: {
      paymentMethodId: string
      installmentAmount?: number
    },
  },
  subscriptionBookingId: string
};

export type PayNextSubscriptionCycleMutationReturnType = undefined

export const payNextSubscriptionCycleEndpoint = (subscriptionBookingId: string) => `memberships/${subscriptionBookingId}/payCurrentCycle`

export type PayNextSubscriptionCycleMuOp = UseMutationOptions<
  PayNextSubscriptionCycleMutationReturnType,
  AxiosError,
  PayNextSubscriptionCycleOptions
>

export const payNextSubscriptionCycle = (params?: PayNextSubscriptionCycleMuOp): PayNextSubscriptionCycleMuOp => {

  return ({
    mutationFn: async (options) => {
      const res = await API.post<PayNextSubscriptionCycleOptions, PayNextSubscriptionCycleMutationReturnType>(
        payNextSubscriptionCycleEndpoint(options.subscriptionBookingId),
        options.data
      )
      return res.data
    },
    ...params
  })
}

